export const formSubmmitMapper = (data) => ({
  nama_item_sumber_daya: data?.namaItem,
  keterangan: data?.keterangan,
  id_satuan: data?.idSatuan,
  id_kategori_anggaran: data?.idKategori,
  id_item_sumber_daya: data?.idItem,
});
